import React, { useState, useEffect } from "react";
import { useGetDepartmentUserMappings, useGetDepartments, useGetVerticals } from "../../../backend/masters";
import { DEFAULT_OPTIONS_PAYLOAD } from "../../common/Table";
import { toast } from "react-toastify";
import { API_RESULT, ERROR_MESSAGES } from "../../../utils/constants";
import FormRenderer, { ComponentMapper, FormTemplate, componentTypes } from "../../common/FormRenderer";
import { getValue, preventDefault } from "../../../utils/common";
import { validatorTypes } from "@data-driven-forms/react-form-renderer";
import { Button, Modal } from "react-bootstrap";
import { useUpdateComplianceSchedule } from "../../../backend/compliance";
import { ResponseModel } from "../../../models/responseModel";
import { USER_PRIVILEGES } from "../UserManagement/Roles/RoleConfiguration";
import PageLoader from "../../shared/PageLoader";
import { AxiosError } from "axios";

export default function ComplianceAssignUser(this: any, { activities, onCancel }: any) {
    const activity = activities[0];
    const [t] = useState(new Date().getTime());
    const [form, setForm] = useState<any>({});
    const [data, setData] = useState<any>({ hideButtons: true });
    const [company, setCompany] = useState<any>(null);
    const [owners, setOwners] = useState<any[]>([]);
    const [managers, setManagers] = useState<any[]>([]);
    const [vertical, setVertical] = useState<any>(null);
    const [department, setDepartment] = useState<any>(null);
    const [requests, setRequests] = useState<any[]>([]);
    const [complianceUpdating, setComplianceUpdating] = useState(false);
    const [updateCount, setUpdateCount] = useState<number>(0);
    const { verticals } = useGetVerticals({
        ...DEFAULT_OPTIONS_PAYLOAD,
        filters: {company_id_eq: (company || {}).value }, t
    }, Boolean(company));
    const { departments } = useGetDepartments({
        ...DEFAULT_OPTIONS_PAYLOAD,
        filters: {vertical_id_eq: (vertical || {}).value }, t
    }, Boolean(vertical));
    const { departmentUsers, isFetching } = useGetDepartmentUserMappings({
        ...DEFAULT_OPTIONS_PAYLOAD,
        filters: {department_id_eq: (department || {}).value, is_active_eq: true }
    }, Boolean(department));
    const { updateComplianceSchedule, updating } = useUpdateComplianceSchedule((response: ResponseModel) => {
        if (response instanceof AxiosError){
            const data = (response.response || {}).data;
            const error = (data || {}).error || ERROR_MESSAGES.DEFAULT;
            setComplianceUpdating(false);
            toast.error(error);
        } else {
            setUpdateCount(updateCount + 1);
        }
    }, errorCallback);

    function errorCallback() {
        toast.error(ERROR_MESSAGES.DEFAULT);
    }

    const schema = {
        fields: [
            {
                component: componentTypes.PLAIN_TEXT,
                name: 'company.name',
                label: 'Company',
                content: getValue(activity, 'company.name')
            },
            {
                component: componentTypes.SELECT,
                name: 'vertical',

                label: 'Vertical',
                options: verticals,
                onChange: handleVerticalChange.bind(this),
                validate: [
                    { type: validatorTypes.REQUIRED }
                ]
            },
            {
                component: componentTypes.SELECT,
                name: 'department',
                label: 'Department',
                options: departments,
                onChange: handleDepartmentChange.bind(this),
                validate: [
                    { type: validatorTypes.REQUIRED }
                ]
            },
            {
                component: componentTypes.SELECT,
                name: 'owner',
                label: 'Owner',
                options: owners,
                validate: [
                    { type: validatorTypes.REQUIRED }
                ]
            },
            {
                component: componentTypes.SELECT,
                name: 'manager',
                label: 'Manager',
                options: managers,
                validate: [
                    { type: validatorTypes.REQUIRED }
                ]
            }
        ],
    };

    function handleVerticalChange(e: any) {
        setVertical(e);
        setDepartment(null);
        // setData({ ...data, vertical: e, department: null, user: null });
    }

    function handleDepartmentChange(e: any) {
        setDepartment(e);
        // setData({ ...data, department: e, user: null });
    }

    function debugForm(_form: any) {
        setForm(_form);
        setData(_form.values);
    }

    function submit(e: any) {
        preventDefault(e);
        if (form.valid) {
            const { vertical, department, owner, manager } = data;
            const requests = activities.map((activity: any) => {
                return {
                    id: activity.id,
                    vertical_id: vertical.value,
                    department_id: department.value,
                    compliance_owner_id: owner.value,
                    compliance_manager_id: manager.value
                }
            });
            setComplianceUpdating(true);
            const payload = requests.shift();
            setRequests(requests);
            updateComplianceSchedule({compliance: payload});
            setRequests(requests);
            // updateBulkComplianceSchedule(request);
            // const request: any = {
            //     name: name.trim(),
            //     lawId: law.value,
            //     establishment_type: establishment_type ? establishment_type.map((x: any) => x.value).sort().join(API_DELIMITER) : ''
            // };

            // if (action === ACTIONS.EDIT) {
            //     request['id'] = data.id;
            //     updateAct(request);
            // } else {
            //     createAct(request);
            // }
        }
    }

    useEffect(() => {
        if (updateCount && updateCount != activities.length) {
            const tempRequests = [...requests];
            const payload = tempRequests.shift();
            setRequests(tempRequests);
            updateComplianceSchedule({compliance: payload});
        } else if (updateCount === activities.length) {
            toast.success(`User${activities.length > 1 ? "s" : ""} assigned successfully.`);
            setComplianceUpdating(false);
            onCancel(true);
        }
    }, [updateCount]);

    function handleClose() {
        onCancel(false);
    }

    useEffect(() => {
        if (activities) {
            const { company } = activities[0];
            setCompany({ value: company.id, label: company.name });
        }
    }, [activities]);

    useEffect(() => {
        if (isFetching) {
            setOwners([]);
            setManagers([]);
        }
        if (!isFetching && departmentUsers) {
            const _owners = departmentUsers.filter(({user}: any) => {
                if(!user) return false;
                const isOwner = (user.roles || []).find((role: any) => (role.pages || []).includes(USER_PRIVILEGES.OWNER_DASHBOARD));
                return Boolean(isOwner);
            }).map(({user}: any) => user);
            const _managers = departmentUsers.filter(({user}: any) => {
                if(!user) return false;
                const isManager = (user.roles || []).find((role: any) => (role.pages || []).includes(USER_PRIVILEGES.MANAGER_DASHBOARD));
                return Boolean(isManager);
            }).map(({user}: any) => user);
            setOwners(_owners);
            setManagers(_managers);
        }

    }, [isFetching]);

    return (
        <>
            <Modal show={true} backdrop="static" dialogClassName="drawer" animation={false}>
                <Modal.Header closeButton={true} onHide={handleClose}>
                    <Modal.Title className="bg">Assign Owner / Manager</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <FormRenderer FormTemplate={FormTemplate}
                        initialValues={data}
                        componentMapper={ComponentMapper}
                        schema={schema}
                        debug={debugForm}
                    />
                </Modal.Body>
                <Modal.Footer className="d-flex justify-content-between">
                    <Button variant="outline-secondary" className="btn btn-outline-secondary px-4" onClick={handleClose}>{'Cancel'}</Button>
                    <Button variant="primary" onClick={submit} className="px-4" disabled={!form.valid}>{'Submit'}</Button>

                </Modal.Footer>
            </Modal>
            {
                (complianceUpdating) &&
                <PageLoader>
                    Updated Compliance {updateCount + 1} of {activities.length}
                </PageLoader>
            }
        </>
    )
}